<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Add Campaign Steps</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/6 w-full mb-6">
          <h5>Choose Campaign :</h5>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-6">
          <CampaignAutocomplete
            :key="companySearchComponentKey"
            class="searchbox"
            :list="searchCampaign"
            :searchOn="'campaign'"
            @event-name="selectCampaign"
          ></CampaignAutocomplete>
        </div>
      </div>

      <div class="vx-row mb-6">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <h5>Master Steps</h5>
          </div>
        </vs-col>
        <v-multiselect-listbox
          :options="masterSteps"
          :reduce-display-property="option => option.steps"
          :reduce-value-property="option => option.id"
          no-options-found-text="No steps found"
          v-model="selectedMasterSteps"
          no-selected-options-found-text="No selected steps found"
        >
        </v-multiselect-listbox>
      </div>
      <div class="vx-row mb-6">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <h5>Client Steps</h5>
          </div>
        </vs-col>
        <v-multiselect-listbox
          :options="clientCmapignSteps"
          :reduce-display-property="option => option.steps"
          :reduce-value-property="option => option.id"
          no-options-found-text="No steps found"
          v-model="selectedClientCampaignSteps"
          no-selected-options-found-text="No selected steps found"
        >
        </v-multiselect-listbox>
      </div>

      <div class="float-right mt-5 mb-5">
        <vs-button @click="goNext()">Next</vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import Vue from "vue";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vMultiselectListbox from "vue-multiselect-listbox";
import defineAbilitiesFor from "@/config/abilities";
import moduleMasterStepsManagement from "@/store/campaign-management/master-steps-management/moduleMasterStepsManagement.js";
import moduleClientCampaignStepsManagement from "@/store/campaign-management/client-campaign-steps-management/moduleStepsManagement.js";
import "vue-multiselect-listbox/src/scss/vue-multi-select-listbox.scss";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
Vue.component("v-multiselect-listbox", vMultiselectListbox);
export default {
  data: () => ({
    selected_campaign_clients: [],
    selected_campaign: null,
    user_id: null,
    user_role: null,
    companySearchComponentKey: 0,

    abilities: null,
    selectedMasterSteps: [],
    selectedClientCampaignSteps: [],
    paginationAttr: {
      page_no: 1,
      per_page: 100
    },
    masterSteps: [],
    clientCmapignSteps: [],
    getSeletectedCampaignClients: []
  }),
  components: {
    CampaignAutocomplete
  },
  watch: {
     selectedClientCampaignSteps: function(val) {
       if(this.selected_campaign == null){
           this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: `Campaign Steps`,
            text: `Please select the campaign in order to choose campaign steps.`,
            acceptText: "OK"
          });
       }
    },
   
  },
  methods: {
    selectCampaign() {
      let self = this;
      self.selected_campaign =
        moduleCampaignManagement.selected_campaign_and_client;
      let selected_client_id = self.selected_campaign.id;

      this.$store
        .dispatch(
          "campaignsManagement/fetchArrangedCampaignSteps",
          selected_client_id
        )
        .then(res => {
          let result = JSON.parse(res.data);
          if (result.length != 0) {
            this.goToCampaignSteps(selected_client_id);
          }
        })
        .catch(err => {
          console.log(err);
        });

        self.getSeletectedCampaignClients = []

      self.selected_campaign_clients =
        self.selected_campaign.client_campaign_association;
      self.selected_campaign_clients.map(function(scc_ele) {
        self.clientCmapignSteps.filter(function(e) {
          if (scc_ele.id == e.client_id) {
            self.getSeletectedCampaignClients.push(e);
          }
        });
      });


      self.clientCmapignSteps = self.getSeletectedCampaignClients;
      self.selectedClientCampaignSteps = []
    },
    goToCampaignSteps(campaignId) {
      this.$router.push({ path: `/campaigns/steps-dependency/` + campaignId });
    },
    searchCampaign(inputValue) {
      this.fetchMasterSteps();
      this.fetchClientSteps();

      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchMasterSteps() {
      this.$store
        .dispatch(
          "MasterStepsManagement/fetchAllMasterSteps",
          this.paginationAttr
        )
        .then(res => {
          this.masterSteps = moduleMasterStepsManagement.state.steps.datas;
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchClientSteps() {
      let self = this
      try{
        self.$store
          .dispatch(
            "ClientCampaignStepsManagement/fetchAllClientCampaignSteps",
            self.paginationAttr
          )
          .then(res => {
            self.clientCmapignSteps =
              moduleClientCampaignStepsManagement.state.steps.datas;
          })
          .catch(err => {
            console.log(err);
                        if (err.response.status === 401) {
                          self.$router.replace("/login");
      }
          });

      }
      catch{
        if (!moduleClientCampaignStepsManagement.isRegistered) {
      self.$store.registerModule(
        "ClientCampaignStepsManagement",
        moduleClientCampaignStepsManagement
      );
      moduleClientCampaignStepsManagement.isRegistered = true;
    }

    self.fetchClientSteps()
      }
    },
    goBack: function() {
      this.$router.go(-1);
    },
    goNext() {
      if (this.selected_campaign == null) {
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: "Campaign Steps",
          text:
            "The campaign is not selected. Please select the campaign and click to proceed.",
          acceptText: "OK"
        });
        return false;
      }

      //  this.selectedMasterSteps = Object.assign({}, this.selectedMasterSteps);
      //       this.selectedClientCampaignSteps = Object.assign({}, this.selectedClientCampaignSteps);

      let newObj = {};
      newObj.master_steps = this.selectedMasterSteps;
      newObj.client_steps = this.selectedClientCampaignSteps;
      newObj.campaign_id = this.selected_campaign["id"];
      this.$store
        .dispatch("campaignsManagement/addCampaignSteps", newObj)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Campaign Steps",
              text: res.data.message
            });
          } else {
            // this.$vs.notify({
            //   color: "success",
            //   title: "Campaign Steps",
            //   text: "The campaign steps was saved successfully"
            // });
            this.$router.push({
              path:
                `/campaigns/steps-start-end-assign/` + this.selected_campaign["id"]
            });
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  },
  mounted() {

    //   if (localStorage.getItem('reloaded')) {
    //     // The page was just reloaded. Clear the value from local storage
    //     // so that it will reload the next time this page is visited.
    //     localStorage.removeItem('reloaded');
    // } else {
    //     // Set a flag so that we know not to reload the page twice.
    //     localStorage.setItem('reloaded', '1');
    //     location.reload();
    // }

    this.fetchMasterSteps();
    this.fetchClientSteps();
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    if (!moduleClientCampaignStepsManagement.isRegistered) {
      self.$store.registerModule(
        "ClientCampaignStepsManagement",
        moduleClientCampaignStepsManagement
      );
      moduleClientCampaignStepsManagement.isRegistered = true;
    }
    if (!moduleMasterStepsManagement.isRegistered) {
      self.$store.registerModule(
        "MasterStepsManagement",
        moduleMasterStepsManagement
      );
      moduleMasterStepsManagement.isRegistered = true;
    }

    if (!moduleCampaignManagement.isRegistered) {
      self.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style>
.msl-search-list-input {
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
  font-size: 1rem !important;
  height: 50px;
}

.msl-searchable-list__item {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
  font-size: 1rem !important;
  height: 50px;
}
.msl-multi-select__actions {
  font-size: 25px;
}

.msl-multi-select {
  width: 100%;
}
</style>
